<template>
  <div>
    <van-tabbar v-model="active" :fixed="fixed">
      <van-tabbar-item v-for="(item,index) in tabsItems" :key="index" @click="swcTab(item.path)">
        <span>{{item.title}}</span>
        <template slot="icon" slot-scope="props">
          <i class="icon" :class="props.active ? item.iconActive : item.icon"></i>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { Tabbar, TabbarItem } from 'vant'
import Vue from 'vue'

Vue.use(Tabbar).use(TabbarItem)

export default {
  props: {
    tabsItems: {
      type: Array,
      default: []
    },
    fixed: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  data () {
    return {
      tabPaths: [],
      active: 0
    }
  },
  created () {
    this.tabsItems.forEach((obj) => {
      this.tabPaths.push(obj.path)
    })
  },
  methods: {
    swcTab (path) {
      this.$router.replace(path)
    }
  },
  mounted () {
    for (let i = 0; i < this.tabPaths.length; i++) {
      if (this.$route.path === this.tabPaths[i]) {
        this.active = i
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
  @import "@/assets/style/variables.scss";
.van-tabbar-item--active {
  color: $assertive !important;
}
</style>
